import React from 'react';
import { ChartBarIcon } from '@heroicons/react/24/outline';

export const StatusConsolidationMessage: React.FC = () => {
  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-semibold">Consolidação de Status</h2>
        <span className="text-xs text-gray-500">Processando dados</span>
      </div>
      
      <div className="text-center py-8">
        <div className="flex justify-center mb-4">
          <ChartBarIcon className="h-16 w-16 text-blue-500 animate-pulse" />
        </div>
        
        <h3 className="text-lg font-medium text-gray-800 mb-3">
          Dados em Processamento
        </h3>
        
        <div className="mt-4 p-3 bg-green-50 border border-green-200 rounded-lg">
          <p className="text-sm text-green-700 font-medium">
            📊 Os dados aparecerão automaticamente quando houver volume suficiente para análise
          </p>
        </div>
        
        <p className="text-xs text-gray-500 mt-4">
          Atualiza a cada 5 minutos • Processamento contínuo
        </p>
      </div>
    </div>
  );
};
